import IconContainer from '@/components/IconContainer'
import './IconColorClose.css'

export default function IconColorClose(props) {
  props = {
    ...props,
    className: `icon-color-close ${props.className}`
  }
  return (
    <IconContainer {...props} width="16" height="16" ariaLabel="Close Icon">
      <circle className="icon-close-circle" cx="8" cy="8" r="8" />
      <path
        className="icon-close-cross"
        d="M5.44653 10.4124L10.5534 5.30556"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="icon-close-cross"
        d="M10.5534 10.4124L5.44649 5.30555"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconContainer>
  )
}
